import { Link, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import AuthorBox from '../components/AuthorBox'
import StoryCard from '../components/StoryCard'
import { ensureCmsCards, useCmsVersion } from '../cms/store'
import { allAuthors, storiesByAuthorSlug } from '../data/content'
import { publicPath } from '../lib/paths'

const PAGE_SIZE = 8

export default function Author() {
  useCmsVersion()
  const { slug } = useParams()

  useEffect(() => {
    void ensureCmsCards()
  }, [])
  const author = allAuthors().find((person) => person.slug === slug)
  const posts = slug ? storiesByAuthorSlug(slug) : []
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE)

  useEffect(() => {
    document.title = author ? `${author.name} | TIGG` : 'Author | TIGG'
  }, [author])

  useEffect(() => {
    setVisibleCount(PAGE_SIZE)
  }, [slug])

  const visiblePosts = posts.slice(0, visibleCount)
  const hasMore = posts.length > visibleCount

  if (!author) {
    return (
      <main className="py-24 text-center">
        <h1 className="font-serif text-4xl">Author not found</h1>
        <Link to={publicPath('/')} className="mt-6 inline-block text-[11px] tracking-[0.2em] uppercase hover:text-rose">
          Back to TIGG
        </Link>
      </main>
    )
  }

  return (
    <main className="py-[clamp(28px,4.5vw,60px)]">
      <div data-reveal>
        <p className="text-[10px] tracking-[0.2em] text-rose uppercase">The masthead</p>
        <h1 className="mt-3 font-serif text-[clamp(32px,8vw,84px)] leading-[0.98] font-medium tracking-[-0.02em] break-words">
          {author.name}
        </h1>
      </div>
      <div className="mt-10 max-w-[720px]">
        <AuthorBox author={author} showPostsLink={false} />
      </div>
      {posts.length > 0 ? (
        <>
          <div className="mt-12 grid grid-cols-1 gap-x-5 gap-y-8 min-[480px]:grid-cols-2 md:grid-cols-4">
            {visiblePosts.map((story, index) => (
              <StoryCard key={story.slug} story={story} stagger={index} compact />
            ))}
          </div>
          {hasMore && (
            <div className="mt-12 flex justify-center">
              <button
                type="button"
                onClick={() => setVisibleCount((count) => count + PAGE_SIZE)}
                className="text-caps h-12 bg-ink px-8 text-white hover:bg-rose"
              >
                Load more
              </button>
            </div>
          )}
        </>
      ) : (
        <p data-reveal className="mt-12 max-w-[52ch] leading-relaxed text-copy text-muted">
          No posts by {author.name} yet.
        </p>
      )}
    </main>
  )
}
